import { Pipe, PipeTransform } from '@angular/core';
import moment from "moment";
import {TranslateService} from "@ngx-translate/core";

@Pipe({
    name: 'span',
    standalone: false
})
export class SpanPipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value: {start: Date|string, end?: Date|string}, ...args: unknown[]): string {
    if(value && value.start) {
      const end = moment(value.end || new Date());
      const start = moment(value.start);

      const duration = moment.duration(end.diff(start));
      return duration.locale(this.translate.currentLang).humanize({w: 4, M:12});
    }
    return null;
  }

}
